export default "__VITE_ASSET__Cuce96xu__"